export default "__VITE_ASSET__DxkGtEBT__"